<title>{{ IAGPortalProductUpdateNotificationsPage.htmlTitle }}</title>
<div class="row">
  <div class="col-sm-2 col-md-3 col-sm-4">
    <label class="smlx">Start Date</label>
    <input class="form-input indate" id="startDate" name="startDate" #startDate type="date" [value]="fromDate" />
  </div>

  <div class="col-sm-2 col-md-3 col-sm-4">
    <label class="smlx">End Date</label>
    <input class="form-input indate" id="endDate" name="ddate2" type="date" #endDate [value]="toDate" />
  </div>

  <div class="col-sm-2 col-md-3 col-sm-4">
    <br />
    <button class="ba-btn ba-btn-thin vsml" role="button" type="button" (click)="getRevisionNoticesWithinTheRange(startDate.valueAsDate, endDate.valueAsDate)">
      <i class="fa fa-reload"></i> Update
    </button>
  </div>
</div>

<app-ndc-product-update-notifications-page-table-section
  *ngIf="!filterButtonUsed"
  [tableData]="tableDataToDisplayOnPageFirstLoad"
  [productUpdateNoteFound]="IAGPortalProductUpdateNotificationsPage.productUpdateNotFound"
>
</app-ndc-product-update-notifications-page-table-section>

<app-ndc-product-update-notifications-page-table-section
  *ngIf="filterButtonUsed"
  [tableData]="tableDataFilteredByData"
  [productUpdateNoteFound]="IAGPortalProductUpdateNotificationsPage.productUpdateNotFound"
  [showItemsWithoutReversingOrder]="true"
></app-ndc-product-update-notifications-page-table-section>
